import React, { Component } from 'react'
import HomeIcon from "@mui/icons-material/Home";
import Stack from '@mui/material/Stack';
import AdminPortalRoutes from '../../../routes/AdminPortalRoutes';
import BaseLayout from '../../../components/admin_portal/BaseLayout';

class AdminPortalContainer extends Component {

  handleChangePasswordOpen = (newVal) => {
    this.props.setChangePasswordOpen(newVal);
  }

  render() {
    const {is_open,change_password,company_details} = this.props;
    return (
      <Stack>
        <BaseLayout 
        ChildComponent={AdminPortalRoutes} 
        is_open = {is_open} 
        handleChangePasswordOpen = {this.handleChangePasswordOpen} 
        change_password = {change_password}
        company_details = {company_details}
        />
      </Stack>
    )
  }
}

export default AdminPortalContainer;